import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionItemsApi = {
    getTrialInstitutionItemById: (id: number): Observable<Dtos.GetTrialInstitutionItemByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionItemById = new Dtos.GetTrialInstitutionItemById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionItemByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionItemsByTrialInstitutionId: (id: number): Observable<Dtos.GetTrialInstitutionItemsByTrialInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionItemsByTrialInstitutionId = new Dtos.GetTrialInstitutionItemsByTrialInstitutionId();

        request.trialInstitutionId = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionItemsByTrialInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionItemsSiteClosure: (trialInstitutionIds: number[]): Observable<Dtos.GetTrialInstitutionItemsSiteClosureResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionItemsSiteClosure = new Dtos.GetTrialInstitutionItemsSiteClosure();

        request.trialInstitutionIds = trialInstitutionIds;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionItemsSiteClosureResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialInstitutionItem: (trialInstitutionItem: Dtos.TrialInstitutionItem, _collection: Dtos.Collection): Observable<Dtos.SetTrialInstitutionItemResponse> => {
        let request: Dtos.SetTrialInstitutionItem = new Dtos.SetTrialInstitutionItem();

        request.trialInstitutionItem = trialInstitutionItem;
        // request.collection = collection;

        // send request
        const response: Promise<Dtos.SetTrialInstitutionItemResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialInstitutionItem: (trialInstitutionId: number): Observable<Dtos.CreateTrialInstitutionItemResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialInstitutionItem = new Dtos.CreateTrialInstitutionItem();

        request.trialInstitutionId = trialInstitutionId;

        //Send request.
        const response: Promise<Dtos.CreateTrialInstitutionItemResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}